import * as frameworkExports from './exports'

export const sparkyFramework = Object.freeze(Object.defineProperties(frameworkExports, {
  __DEBUG_ON: { get: frameworkExports.__isDebugOn }
}))

export type SparkyFramework = typeof sparkyFramework

export default sparkyFramework
